import { ComponentRef, ViewContainerRef } from '@angular/core';

class LanguageFormSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  // currentHandler: (response: com.ts.mobile.sdk.InputOrControlResponse<any>) => void;
  viewContainerRef: ViewContainerRef;

  constructor(formId: string, payload: object) {

      this.formId = formId;
      this.payload = payload;
  }
  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {

    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.viewContainerRef = (clientContext as any).viewContainerRef;

  }
  endSession(): void {


    setTimeout(this.checkUserLocked, 2000);

  }
  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {

    return new Promise((resolve, reject) => {
        try {
          const currentLanguage = this.clientContext['cookieService'].get('lang');
          const payload = {language: currentLanguage};

          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));

          this.submitBlock = null; // prevent reuse of a settled promise
        } catch (e) {

          console.error(e);
        }
    });
  }
  onContinue(payload: object): void {

  }
  onError(payload: object): void {

  }

    // check if we have locked user dialog box in DOM
    private checkUserLocked() {
      const transmitContainerHTML = document.getElementById('transmitContainer').innerHTML;
      const str = 'User Locked';
      const lockedFound = transmitContainerHTML.includes(str);

      if (transmitContainerHTML.indexOf(str) !== -1){
        console.error('User is locked by Transmit');
        const continueBtn: HTMLElement = document.querySelectorAll('button.xmui-button')[0] as HTMLElement;
        console.error('continueBtn ', continueBtn);
        continueBtn.click();
      }
      else {
        console.error('User is NOT locked by Transmit');
      }
    }
}

export default LanguageFormSession;
